var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [
        _vm._v(_vm._s(_vm.$ct("common.duplicate_prop", { Prop: "tab" }))),
      ]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _vm.isSet
                    ? _c("w-input", {
                        attrs: {
                          required: "",
                          fancy: "",
                          label: _vm.$ct("common.name"),
                        },
                        model: {
                          value: _vm.duplicateView.Name,
                          callback: function ($$v) {
                            _vm.$set(_vm.duplicateView, "Name", $$v)
                          },
                          expression: "duplicateView.Name",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.duplicate()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.duplicate")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }